export default __webpack_public_path__ + "static/media/1082.915ef6a3.png";